import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export const downloadExcel = ({ fileName, sheet, tablePayload }) => {
    if (!tablePayload) return;

    const { header = [], body = [] } = tablePayload;

    // Normalizamos header: puede venir como array de strings o de defs de columnas.
    const headerLabels = header.map((col) => {
        if (typeof col === 'string') return col;
        return col.headerName || col.label || col.field || '';
    });

    let rows = [];

    if (!body || body.length === 0) {
        rows = [];
    } else if (Array.isArray(body[0])) {
        // Caso 1: body es array de arrays -> [ [..row1], [..row2], ... ]
        rows = body;
    } else if (typeof body[0] === 'object') {
        // Caso 2: body es array de objetos
        if (typeof header[0] === 'string') {
            // Header decorativo -> respetamos el orden en que armaste los objetos
            rows = body.map(obj => Object.values(obj));
        } else {
            // Header con metadatos -> seguimos field/key/headerName
            const headerKeys = header.map(col => {
                if (typeof col === 'string') return col;
                return col.field || col.key || col.headerName || '';
            });

            rows = body.map(row =>
                headerKeys.map(key => (key ? row[key] ?? '' : ''))
            );
        }
    } else {
        rows = body;
    }

    // Construimos hoja: primera fila = header, resto = body
    const sheetData = [headerLabels, ...rows];

    const worksheet = XLSX.utils.aoa_to_sheet(sheetData);

    // 🔹 Ajustar ancho de columnas según el contenido más largo
    const colCount = headerLabels.length;
    const colWidths = new Array(colCount).fill(0).map((_, colIndex) => {
        let maxLen = 0;
        for (let rowIndex = 0; rowIndex < sheetData.length; rowIndex++) {
            const cellValue = sheetData[rowIndex][colIndex];
            const len = cellValue == null ? 0 : cellValue.toString().length;
            if (len > maxLen) maxLen = len;
        }
        // un pequeño padding
        return { wch: maxLen + 2 };
    });
    worksheet['!cols'] = colWidths;

    // 🔹 Centrar todo el contenido (header + filas)
    if (worksheet['!ref']) {
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let R = range.s.r; R <= range.e.r; ++R) {
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const addr = XLSX.utils.encode_cell({ r: R, c: C });
                const cell = worksheet[addr];
                if (!cell) continue;

                cell.s = {
                    ...(cell.s || {}),
                    alignment: { horizontal: 'center', vertical: 'center' },
                };
            }
        }
    }

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, sheet || 'Sheet1');

    const excelBuffer = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
        cellStyles: true, // necesario para que respete alignment en muchos viewers
    });

    const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const finalName = fileName?.toString().replace(/\.xlsx$/i, '') || 'export';
    saveAs(blob, `${finalName}.xlsx`);
};
